import { jsPDF } from "jspdf";
import logo from "../Assets/Images/Lendriva_logo.jpg";

export type TransactionReceiptData = {
  paymentId?: string;
  uuid?: string;
  amount?: number | string;
  chargedAmount?: number | string;
  status?: string;
  transactionType?: string;
  transactionDate?: string;
  createdAt?: string;
  remarks?: string;
};

export const generateTransactionReceiptPdf = (
  transaction: TransactionReceiptData
): jsPDF => {
  const doc = new jsPDF();
  const margin = 14;
  const pageWidth = doc.internal.pageSize.getWidth();
  let y = 16;

  const logoWidth = 36;
  const imgProps = doc.getImageProperties(logo);
  const logoHeight = (logoWidth * imgProps.height) / imgProps.width;
  doc.addImage(logo, "JPEG", pageWidth - logoWidth - margin, y, logoWidth, logoHeight);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("Transaction Receipt", margin, y + 8);

  y += logoHeight + 14;
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  const dateValue = transaction.transactionDate || transaction.createdAt;
  const rows: [string, string][] = [
    ["Receipt No.", transaction.paymentId || transaction.uuid || "—"],
    ["Date", dateValue ? new Date(dateValue).toLocaleString("en-GB") : "—"],
    ["Transaction Type", transaction.transactionType || "—"],
    ["Amount", `£${Number(transaction.amount ?? 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`],
    [
      "Fees / Charges",
      `£${Number(transaction.chargedAmount ?? 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    ],
    ["Status", transaction.status || "—"],
    ["Remarks", transaction.remarks || "—"],
  ];

  rows.forEach(([label, value]) => {
    doc.setFont("helvetica", "bold");
    doc.text(`${label}:`, margin, y);
    doc.setFont("helvetica", "normal");
    const lines = doc.splitTextToSize(value, pageWidth - margin * 2 - 42);
    doc.text(lines, margin + 42, y);
    y += Math.max(lines.length * 5, 7) + 2;
  });

  y += 8;
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(
    "This is a system-generated receipt from Lendriva. Please retain for your records.",
    margin,
    y
  );

  return doc;
};

export const downloadTransactionReceipt = (transaction: TransactionReceiptData) => {
  const doc = generateTransactionReceiptPdf(transaction);
  const receiptId = transaction.paymentId || transaction.uuid || "receipt";
  doc.save(`Lendriva_Receipt_${receiptId}.pdf`);
};
